import { validateHTTPS, validateHaveCookieName } from '../../helpers';
import commonConstant from '../../common/_commonConstant';

export const createCookie = (name, value, expires) => {
  try {
    if (name && value) {
      return document.cookie = `${name}=${value}; expires=${expires ? new Date(expires).toUTCString() : ''}; domain=${commonConstant.envCookieDomain ? commonConstant.envCookieDomain : ''}; path=/${validateHTTPS(window.location.href) ? '; secure' : ''}`;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const getCookie = name => {
  try {
    if (name) {
      const parts = `; ${document.cookie}`.split(`; ${name}=`);
      if (parts.length === 2) {
        return parts.pop().split(';').shift();
      }
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const deleteCookie = name => {
  try {
    if (name) {
      if (validateHaveCookieName(name)) {
        return document.cookie = `${name}=; expires=${new Date(new Date().setDate(new Date().getDate() - 1)).toUTCString()}; domain=${commonConstant.envCookieDomain ? commonConstant.envCookieDomain : ''}; path=/${validateHTTPS(window.location.href) ? '; secure' : ''}`;
      }
    }
    return null;
  } catch (error) {
    return null;
  }
};
